import { render, staticRenderFns } from "./Custom_module.vue?vue&type=template&id=b0383118&"
import script from "./Custom_module.vue?vue&type=script&lang=js&"
export * from "./Custom_module.vue?vue&type=script&lang=js&"
import style0 from "./Custom_module.vue?vue&type=style&index=0&id=b0383118&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports